<template>
    <router-view :class="className"></router-view>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        className:''
      }
    },
    beforeMount:function (){  
			
	},
  }
</script>

<style>
	@import url("./assets/css/common.css");
	/* @import url("./assets/css/swiper.min.css"); */
	@import url("./assets/css/font-awesome.min.css");

  
  	

</style>
